module.exports = __webpack_public_path__ + "img/laser-turret-gun.173f471d.png";